export class TourPatterns {
    public static readonly patterns = {
        tvetTable: {
            routePattern: /^\/accreditations\/tvet-accreditations$/,
            tour: [
                {
                  anchorId: "search-case-number",
                  title: "Search by Case Number",
                  content:
                    "Enter a case number here to quickly find specific accreditation requests",
                },
                {
                  anchorId: "create-accreditation",
                  title: "Create New Accreditation",
                  content:
                    "Click here to submit a new TVET accreditation request for your institution",
                },
              ],
        },
        tvetView: {
            routePattern: /^\/accreditations\/tvet-accreditations\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
            tour: [
                {
                  anchorId: "application-status",
                  title: "Application Status",
                  content:
                    "Shows the current status of your accreditation request. This updates as your application moves through different stages of the process.",
                  order: 1
                },
                {
                  anchorId: "preassessment-result",
                  title: "Pre-assessment Result",
                  content:
                    "Indicates whether your initial documentation is complete. Click here to see detailed pre-assessment findings and any required actions.",
                  order: 2
                },
                {
                  anchorId: "evaluation-decision",
                  title: "Evaluation Decision",
                  content:
                    "The final decision on your accreditation request after complete evaluation. This shows whether your application was approved or rejected.",
                  order: 3
                },
                {
                  anchorId: "total-score",
                  title: "Total Score",
                  content:
                    "Your institution's overall score from the evaluation process. A minimum of 75% is required for approval.",
                  order: 4
                },
                {
                  anchorId: "basic-info-tab",
                  title: "Step 1: Basic Information",
                  content:
                    "Let's start with the basic details. This is where you'll enter fundamental information about your institution and accreditation request.",
                  order: 5
                },
                {
                  anchorId: "program-details-tab",
                  title: "Step 2: Program Details",
                  content:
                    "Next, provide specific information about your TVET program, including its structure, duration, and capacity.",
                  order: 6
                },
                {
                  anchorId: "previous-trainings-tab",
                  title: "Step 3: Training History",
                  content:
                    "Share your institution's experience by documenting previous training programs and their outcomes.",
                  order: 7
                },
                {
                  anchorId: "trainee-assessments-tab",
                  title: "Step 4: Assessment Methods",
                  content:
                    "Explain how you evaluate and assess trainee performance to ensure quality education.",
                  order: 8
                },
                {
                  anchorId: "admin-staff-tab",
                  title: "Step 5: Administrative Team",
                  content:
                    "Tell us about your administrative staff who will manage and support the program.",
                  order: 9
                },
                {
                  anchorId: "trainer-details-tab",
                  title: "Step 6: Training Staff",
                  content:
                    "Introduce your qualified trainers who will be delivering the program content.",
                  order: 10
                },
                {
                  anchorId: "training-room-tab",
                  title: "Step 7: Training Facilities",
                  content:
                    "Describe your training rooms and facilities where learning will take place.",
                  order: 11
                },
                {
                  anchorId: "library-details-tab",
                  title: "Step 8: Library Resources",
                  content:
                    "Detail your library facilities and learning resources available to trainees.",
                  order: 12
                },
                {
                  anchorId: "computer-center-tab",
                  title: "Step 9: IT Infrastructure",
                  content:
                    "Outline your computer facilities and technical resources that support training.",
                  order: 13
                },
                {
                  anchorId: "input-checklists-tab",
                  title: "Step 10: Quality Checklists",
                  content:
                    "Complete important checklists to verify your institution meets all required standards.",
                  order: 14
                },
                {
                  anchorId: "documents-tab",
                  title: "Final Step: Documentation",
                  content:
                    "Finally, upload all required documents to support your application. Make sure to include all necessary certificates and supporting materials.",
                  order: 15
                },
              ]
              
        }
    };

}
